import type { ReactElement } from 'react';
import { MINUTES_PER_DAY, mod } from '../../../domain/scheduling/scheduleMath';
import { minuteToPercent } from './timelineUtils';

interface NowLineProps {
  minuteOfDay: number;
}

/** Vertical red line marking the current simulated time across every track. */
export function NowLine({ minuteOfDay }: NowLineProps): ReactElement {
  const left = minuteToPercent(mod(minuteOfDay, MINUTES_PER_DAY));
  return <div className="fsg-now-line" style={{ left: `${left}%` }} aria-hidden="true" />;
}
